
import { fromResult,  LoadingAdditional, AsyncResult, Loaded, Loading,  NotFound, ServerError} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import {pipe} from 'fp-ts/lib/pipeable';
import {PolicyApplicationDto} from 'Agent/Policies/api';
import policyApi from 'Agent/Policies/api/policyApi';
import {
  changeApplications,
  getApplications,
  PolicyApplicationsActionType,
} from 'Agent/Policies/ducks/policyApplications';
import {mergeWithNextPage} from 'Shared/utilities/PageUtility';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import policyServiceRequestApi from '../api/policyServiceRequestApi';
import {getAxiosConfig, getUrlFromUri, handleResponse} from 'Shared/utilities/fetchHelpers';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import {
  addressIsValidating,
  AddressResponse,
  changeValidateAddress,
  PolicyServiceRequestActionType,
  validateAddress,
} from '../ducks/policyServiceRequest';
import axios from 'Shared/utilities/axiosInstance';
import { toSortQuerystringParams } from 'Shared/components/PagedView/Table/Sort';

function* getPolicyApplicationsFromApi(action: ReturnType<typeof getApplications>) {
  if (action.payload.page) {
    action.payload.page.links.forEach(x => {
      if (!x.href.includes('api/policies/')) {
        x.href = 'api/policies/'+ x.href;
      }  
    });
    yield put(changeApplications(new LoadingAdditional(action.payload.page)));
  } else {
    yield put(changeApplications(new Loading(action.payload.page)));
  }
  const parameters = addFilterParameters(action.payload.filter, 'post').slice(1);
  let bodyParams = new URLSearchParams();
  if(parameters) {
    parameters.split('&').forEach((value) => {
      let keyValue = value?.trim().split('=')
      bodyParams?.append(keyValue[0]?.trim(), keyValue[1]?.trim());
    })
  }
  if(action.payload.sort && toSortQuerystringParams(action.payload.sort)) {
    bodyParams.append("sortOrder", (action.payload.sort && toSortQuerystringParams(action.payload.sort)).sortOrder);
    bodyParams.append("sortColumn", (action.payload.sort && toSortQuerystringParams(action.payload.sort)).sortColumn);
  }
  bodyParams.append('encryptedIdentifier', action.payload.encryptedIdentifier);
  if(action.payload.page)bodyParams.append('pageNumber', (action.payload.page?.currentPageNumber+1).toString())

  const result: AsyncResult<Page<PolicyApplicationDto>> = yield action.payload.page
    ? call(mergeWithNextPage, {existingPage: action.payload.page}, 1, bodyParams)
    : call(
        policyApi.getPolicyApplications,
        bodyParams
      );

  yield pipe(
    result,
    E.map(fromResult),
    E.fold(
      value => put(changeApplications(value)),
      value => put(changeApplications(value))
    )
  );
}
export function* validateAddressWithApi(action: ReturnType<typeof validateAddress>) {
  yield put(changeValidateAddress(new Loading()));
  yield put(addressIsValidating(true));
  const {address, address2, city, state, zip} = action.payload.address;
  
  try {    
    const result: AsyncResult<AddressResponse> = yield call(() =>
    policyServiceRequestApi.getValidatedAddress(address!, address2!, city!, state!, zip!).then()
    );

    if (E.isRight(result)) {
      if (result.right.addressValidatedCode === '0002') 
      {yield put(changeValidateAddress(new Loaded(result.right)));

      }
      else
        yield put(changeValidateAddress(new NotFound()));
    } else {
      yield put(changeValidateAddress(new NotFound()));
    }
  } catch {
    yield put(changeValidateAddress(new ServerError()));
  } finally {
    yield put(addressIsValidating(false));
  }
}
export const getValidatedAddress = (address: string, address2: string, city: string, state: string, zip: string) => {
    const axiosConfig = getAxiosConfig();
    const ADDRESS_ROOT_URL: string = 'api/communication/v1/addressValidation';
    return axios
      .get(getUrlFromUri(`${ADDRESS_ROOT_URL}${addFilterParameters({address, address2, city, state, zip})}`), {
        ...axiosConfig,
        headers: {
          ...axiosConfig.headers,
        },
      })
      .then(handleResponse);
  };
  export function* fetchAddressValidation() {
    yield takeLatest(PolicyServiceRequestActionType.VALIDATE_ADDRESS, validateAddressWithApi);
  }

export function* getPolicyApplicationsSaga() {
  yield takeLatest(PolicyApplicationsActionType.FETCH_APPLICATIONS, getPolicyApplicationsFromApi);
}

export default function*() {
  yield all([getPolicyApplicationsSaga(),fetchAddressValidation()]);
}
